import { ApiState } from "@/store/general.types";
import { mutate } from "@/store/plugins/mutation-handler";
import { PaginatedCitationFiles, ProcessingCitationFileDetail, ProcessingFilesCounts, SignedFileDetail, StudyState, UserProcessingFileStatusCounts } from "./study.types";
import { Author } from 'src/views/Screening/types/duplicate-citation-records.types';

export const studyMutations = {
    GET_CITATION_UPLOAD_SIGNED_URL(state: StudyState, newState: ApiState<SignedFileDetail>) {
        mutate(state, newState, 'getCitationUploadSignedUrl');
    },
    GET_BULK_CITATION_UPLOAD_SIGNED_URLS(state: StudyState, newState: ApiState<SignedFileDetail[]>) {
        mutate(state, newState, 'getBulkCitationUploadSignedUrls');
    },
    GET_PROCESSING_CITATION_FILES(state: StudyState, newState: ApiState<ProcessingCitationFileDetail[]>) {
        mutate(state, newState, 'getProcessingCitationFiles');
    },
    GET_PROCESSING_FILES_COUNTS(state: StudyState, newState: ApiState<ProcessingFilesCounts>) {
        mutate(state, newState, 'getProcessingFilesCounts');
    },
    GET_USER_PROCESSING_FILE_STATUS_COUNTS(state: StudyState, newState: ApiState<UserProcessingFileStatusCounts>) {
        mutate(state, newState, 'getUserProcessingFileStatusCounts');
    },
    UNTRACK_FILES_STATUS(state: StudyState, newState: ApiState<void>) {
        mutate(state, newState, 'untrackFilesStatus');
    },
    UNTRACK_FILES_BY_STATUS(state: StudyState, newState: ApiState<void>) {
        mutate(state, newState, 'untrackFilesByStatus');
    },
    GET_FAILED_IMPORTS(state: StudyState, newState: ApiState<PaginatedCitationFiles>) {
        mutate(state, newState, 'getFailedImports');
    },
    GET_IMPORTED_CITATION_FILES(state: StudyState, newState: ApiState<PaginatedCitationFiles>) {
        mutate(state, newState, 'getImportedCitationFiles');
    },
    DELETE_IMPORTED_CITATION_AND_FILE(state: StudyState, newState: ApiState<void>) {
        mutate(state, newState, 'deleteImportedCitationAndFile');
    },
    DOWNLOAD_CORRUPTION_REPORT(state: StudyState, newState: ApiState<string>) {
        mutate(state, newState, 'downloadCorruptionReport');
    },
    GET_USER_LATEST_FAILED_IMPORT(state: StudyState, newState: ApiState<ProcessingCitationFileDetail>) {
        mutate(state, newState, 'getUserLatestFailedImport');
    },
    CREATE_STUDY_NOTE(state: StudyState, newState: ApiState<ProcessingCitationFileDetail>) {
        mutate(state, newState, 'createStudyNote');
    },
    UPDATE_STUDY_NOTE(state: StudyState, newState: ApiState<ProcessingCitationFileDetail>) {
        mutate(state, newState, 'updateStudyNote');
    },
    GET_STUDY_NOTES(state: StudyState, newState: ApiState<StudyState>) {
        mutate(state, newState, 'getStudyNotes');
    },
    EXPORT_CITATIONS(state: StudyState, newState: ApiState<SignedFileDetail>) {
        mutate(state, newState, 'exportCitations');
    },
    GET_AUTHORS_BY_PROJECT(state: StudyState, newState: ApiState<Author[]>) {
        mutate(state, newState, 'getAuthorsByProject');
    },
    GET_PUBLICATION_TYPES(state: StudyState, newState: ApiState<any[]>) {
        mutate(state, newState, 'getPublicationTypes');
    },
    ENTER_RECORD(state: StudyState, newState: ApiState<void>) {
        mutate(state, newState, 'enterRecord');
    },
}
